import { useState } from 'react'
import { ApiHatasi, api, type Kullanici } from '../api'

export function Giris({ onGiris }: { onGiris: (k: Kullanici) => void }) {
  const [eposta, setEposta] = useState('')
  const [parola, setParola] = useState('')
  const [hata, setHata] = useState<string | null>(null)
  const [bekliyor, setBekliyor] = useState(false)

  const gonder = async (e: React.FormEvent) => {
    e.preventDefault()
    setHata(null)
    setBekliyor(true)
    try {
      const r = await api.giris(eposta.trim(), parola)
      onGiris(r.kullanici)
    } catch (err) {
      /**
       * Hata mesajları ayrım yapmıyor.
       *
       * "Bu e-posta kayıtlı değil" demek, kimin sistemde olduğunu
       * sızdırır. Sunucu da aynı cevabı veriyor; burada da öyle.
       */
      if (err instanceof ApiHatasi && err.kod === 'oturum_limiti') {
        setHata(
          'Bu hesapta açık oturum sayısı doldu. Başka bir cihazdan çıkış yapın ya da ' +
            'yöneticinizden yardım isteyin.',
        )
      } else {
        setHata('E-posta veya parola hatalı.')
      }
    } finally {
      setBekliyor(false)
    }
  }

  return (
    <div className="giris">
      <h1>Nirengi</h1>
      <p className="alt">Uygulayıcı paneli</p>
      <form className="kart" onSubmit={gonder}>
        {hata && <div className="uyari">{hata}</div>}
        <label>
          E-posta
          <input
            type="email"
            autoComplete="username"
            value={eposta}
            onChange={(e) => setEposta(e.target.value)}
            required
          />
        </label>
        <label>
          Parola
          <input
            type="password"
            autoComplete="current-password"
            value={parola}
            onChange={(e) => setParola(e.target.value)}
            required
          />
        </label>
        <button className="birincil" type="submit" disabled={bekliyor} style={{ width: '100%' }}>
          {bekliyor ? 'Giriliyor…' : 'Giriş'}
        </button>
      </form>
      <p className="alt" style={{ textAlign: 'center' }}>
        Sağlık verisi tutan bir sistemdesiniz. Ortak kullanılan bir cihazda işiniz bitince
        çıkış yapın.
      </p>
    </div>
  )
}
